export default __webpack_public_path__ + "static/projects-banner-vrcity-6f856a4b18712017eeeb861adf070ec0.svg";